const ORIGIN_DEFAULT_KERNELS: Readonly<Record<string, string>> = Object.freeze({
	'https://hml.app.khal.ai': 'https://hml.hv.khal.ai',
	'https://hml.app.khai.ai': 'https://hml.hv.khal.ai',
});

function normalizeOrigin(raw: string | undefined): string | undefined {
	if (!raw) return undefined;
	try {
		const parsed = new URL(raw);
		return `${parsed.protocol}//${parsed.host.toLowerCase()}`;
	} catch {
		return undefined;
	}
}

export function resolveDefaultKernelForPwaOrigin(args: {
	pwaOrigin: string | undefined;
	buildDefaultKernel?: string;
}): string | undefined {
	const origin = normalizeOrigin(args.pwaOrigin);
	return (origin ? ORIGIN_DEFAULT_KERNELS[origin] : undefined) ?? args.buildDefaultKernel;
}
